var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccBars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8372",
    "data-name": "Rectangle 8372",
    width: 28,
    height: 28,
    transform: "translate(607 1736)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8371",
    "data-name": "Rectangle 8371",
    width: 22.301,
    height: 22.378,
    transform: "translate(2.85 2.81)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bars",
    transform: "translate(-607 -1736)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35218",
    "data-name": "Group 35218",
    transform: "translate(607 1736.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35217",
    "data-name": "Group 35217",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35867",
    "data-name": "Path 35867",
    d: "M24.725,5.3a1.46,1.46,0,0,0-1-2.487H4.33a1.426,1.426,0,0,0-1,2.487l9.241,9.366v7.626h-1.5a2.944,2.944,0,0,0-2.914,2.9H19.73a2.943,2.943,0,0,0-2.913-2.9h-1.5V14.663Zm-14.4,3.067L7.493,5.546H20.48L17.65,8.364Z",
    fill: "#b3b5c4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccBars);
export default __webpack_public_path__ + "static/media/mcc_bars.555963845b60804a0ef92cb6fcac1804.svg";
export { ForwardRef as ReactComponent };